import PreloadImg from 'src/components/common/preload-img/preload-img';
import { useDisclosure } from '@chakra-ui/react';
import { ArticleDetailModal } from 'src/app/article/detail-modal';
import Router from 'next/router';
import { imageOptimize } from 'src/service/image';
import { useIsMobile } from 'src/hooks/use-is-mobile';

interface Props {
  data: Object;
  className?: string;
}
const Episode = ({ data, className = '' }: Props) => {
  const rand = Date.now();
  const repplModal = useDisclosure();
  const isMobile = useIsMobile();

  const link = `/reppl/${data['parent']}/episode/${data['contentID']}`;
  const linkHandle = (e) => {
    e.stopPropagation();
    // repplModal.onOpen();
    Router.push(link);
  };

  return (
    <>
      <a
        className={`episode-image-box${rand} block relative text-white ${
          !isMobile && 'card'
        } episode-card bg-center bg-cover rounded overflow-hidden ${className}`}
        role="button"
        tabIndex={0}
        onClick={linkHandle}
        onKeyDown={linkHandle}
      >
        {data['coverImgURL'] === '' && <PreloadImg height={200} />}
        <div className="absolute p-4 top-0 left-0 w-full">
          <span className="bg-gray-900 text-xs font-bold px-2 py-1 rounded">
            {data['official'] ? 'Official' : 'Open'}
          </span>
        </div>
        <div className="absolute font-bold px-6 bottom-6 left-0 w-full z-10 line-clamp-2">
          {data['title']}
        </div>
        <ArticleDetailModal
          source={data['source']}
          modal={repplModal}
          publish
          id={data['contentID']}
        />
      </a>
      <style jsx>
        {`
          .episode-image-box${rand} {
            background-image: url('${imageOptimize({
              url: data['coverImgURL'],
              imgContainer: 'postCover',
            })}');
            background-size: cover;
            background-repeat: no-repeat;
            background-position: center center;
          }
        `}
      </style>
    </>
  );
};

export default Episode;
